import React, { useState } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { 
    TextField, 
    Grid, 
    Typography, 
    Box,
    Popover,
    IconButton
} from '@mui/material';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';

// Популярные эмодзи для разделов базы знаний
const emojiCategories = {
    'Общие': ['📋', '📝', '📄', '📊', '📈', '📉', '📌', '📍', '🔍', '🔎'],
    'Технологии': ['💻', '📱', '⌨️', '🖥️', '🖨️', '📞', '☎️', '📠', '💾', '💿'],
    'Документы': ['📁', '📂', '🗂️', '🗃️', '📑', '📜', '📋', '📄', '📃', '📰'],
    'Коммуникация': ['💬', '💭', '🗨️', '🗯️', '💌', '📧', '📨', '📩', '📤', '📥'],
    'Помощь': ['❓', '❔', '❗', '❕', '💡', '🔧', '🛠️', '⚙️', '🔩', '⚡'],
    'Категории': ['🏷️', '🔖', '📚', '📖', '📗', '📘', '📙', '📕', '📓', '📔'],
    'Статус': ['✅', '❌', '⭐', '🔴', '🟡', '🟢', '🔵', '🟣', '🟠', '⚫'],
    'Стрелки': ['➡️', '⬅️', '⬆️', '⬇️', '↗️', '↘️', '↙️', '↖️', '🔄', '🔃']
};

const EmojiInput = ({ dispatch, input: { ...inputProps }, meta: { touched, error } = {}, isLoading, label, disabled, style, ...props }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    
    const handleEmojiClick = (emoji) => {
        inputProps.onChange(emoji);
        setAnchorEl(null);
    };

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <TextField
                error={!!(touched && error)}
                helperText={touched && error}
                {...inputProps}
                value={inputProps.value || ''}
                {...props}
                style={style}
                fullWidth
                label={label}
                disabled={isLoading || disabled}
                variant="standard"
                InputProps={{
                    readOnly: true,
                    style: { fontSize: '1.5rem', textAlign: 'center' }
                }}
            />
            <IconButton 
                onClick={handlePopoverOpen}
                size="small"
                color="primary"
            >
                <EmojiEmotionsIcon />
            </IconButton>
            
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Box p={2} maxWidth={400}>
                    {Object.entries(emojiCategories).map(([category, emojis]) => (
                        <Box key={category} mb={2}>
                            <Typography variant="subtitle2" gutterBottom>
                                {category}
                            </Typography>
                            <Grid container spacing={0.5}>
                                {emojis.map((emoji, index) => (
                                    <Grid item key={index}>
                                        <IconButton
                                            onClick={() => handleEmojiClick(emoji)}
                                            size="small"
                                            sx={{
                                                fontSize: '1.2rem',
                                                minWidth: 32,
                                                minHeight: 32,
                                                '&:hover': {
                                                    backgroundColor: 'action.hover'
                                                }
                                            }}
                                        >
                                            {emoji}
                                        </IconButton>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    ))}
                </Box>
            </Popover>
        </Box>
    );
};

const mapStateToProps = (state, props) => {
    const { fetch } = state;
    return {
        isLoading: !!fetch.loading
    }
}

export default compose(
    connect(mapStateToProps),
)(EmojiInput);

